import React from 'react';

import { observer } from 'mobx-react';

import AddCommentActivities from 'ui/AddCommentActivities';

import TaskActivities from 'stores/TaskDetails/TaskActivities';

import { useStore } from 'utils/hooks/store';

const TaskActivitiesFooter: React.FunctionComponent = (): React.ReactElement => {
  const { taskDetails, session } = useStore();
  const activities = taskDetails.activities as TaskActivities;

  if (session.user?.readOnly) {
    return <></>;
  }

  return (
    <AddCommentActivities
      placeholder="Add a comment or drag and drop files"
      uploadFile={activities.uploadFile}
      sendMessage={activities.addMessage}
    />
  );
};

export default observer(TaskActivitiesFooter);
